"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {// maxWidth: 345,
    },
    dialog: {
      minWidth: 340,
      maxWidth: 600
    },
    content: {
      padding: theme.spacing(3)
    }
  };
});

var AlertDialog = function AlertDialog(_ref) {
  var title = _ref.title,
      body = _ref.body,
      message = _ref.message,
      open = _ref.open,
      handle = _ref.handle;
  var classes = useStyles();

  var confirm = function confirm() {
    handle({
      open: false
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    "aria-labelledby": "simple-dialog-title",
    classes: {
      paper: classes.dialog
    },
    open: open
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, title), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, {
    classes: {
      root: classes.content
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1"
  }, body), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), message && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2"
  }, message)), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "outlined",
    onClick: function onClick() {
      confirm();
    },
    color: "primary"
  }, "Ok")));
};

AlertDialog.propTypes = {};
var _default = AlertDialog;
exports["default"] = _default;